<template>
<div  :aria-busy="loading ? 'true' : 'false'">
	<div v-if="!loading">
		<alert :conditional="user.fb_page_id === null && user.organization.is_mandatoaberto !== 0"
			:classFather="'alert'"
			:message="'alert-facebook'"
			:iconClass="'icon fas fa-warning'"
			:linkShow="true"
			:linkTo="'/perfil'"
			:linkText="'configure'"
			:altLink="'configure-facebook'"
			:close-button="true">
		</alert>

		<section class="content__custom">
				<div class="main-title">
					<h1 class="sent">
						{{ 'sentPlural' | translate | titleCase }}
					</h1>
					<h2>{{ 'my-researches-subtitle' | translate | capitalize }}</h2>
				</div>
				<div class="tabs">
					<nav class="tabs__navigation">
						<ul>
							<li
							    :class="`${activeSection === 'messages' ? 'tabs__navigation--active' : ''}`">
								<a href="#messages" @click.prevent="changeSection('messages')">
									{{ 'messages' | translate | titleCase }}
								</a>
							</li>
							<li
								v-if="1 !== 1"
							    :class="`${activeSection === 'polls' ? 'tabs__navigation--active' : ''}`">
								<a href="#polls" @click.prevent="changeSection('polls')">
									{{ 'polls' | translate | titleCase }}
								</a>
							</li>
						</ul>
					</nav>

					<section
						id="messages"
						:class="`tab__entry-content
						${activeSection === 'messages' ? 'tab__entry-content--active' : ''}`"
					>
						<campaings v-if="activeSection === 'messages'"></campaings>
					</section>
					<section
						v-if="1 !== 1"
						id="polls"
						:class="`tab__entry-content ${activeSection === 'polls' ? 'tab__entry-content--active' : ''}`">
						<listPolls v-if="activeSection === 'polls'"></listPolls>
					</section>
				</div>
		</section>
	</div>
</div>

</template>

<script>

import alert from '../../components/alert/alert.vue';
import campaings from '../campaign/campaigns.vue';
import listPolls from './listPolls.vue';

export default {
	name: 'researchesList',
	components: {
		alert,
		campaings,
		listPolls,
	},
	data() {
		return {
			show: true,
			status_id: 1,
			session: {
				apiKey: sessionStorage.getItem('apiKey'),
				userId: sessionStorage.getItem('userId'),
			},
			dataCollectionPollSelect: null,
			disabledPollData: null,
			filedPollData: null,
			classStatus: null,
			loading: false,
			activeSection: 'messages',
		};
	},
	computed: {
		user() {
			return this.$store.state.user;
		},
	},
	methods: {
		changeSection(section) {
			this.activeSection = section;
			this.resetPagination();
		},
		resetPagination() {
			const query = Object.assign({}, this.$route.query);
			query.page = 1;
			this.$router.replace({ query });
		},
		toggleLoading() {
			this.loading = !this.loading;
		},
		selectTabs() {
			if (this.$route.hash) {
				this.activeSection = this.$route.hash.slice(1);
			}
		},
	},
	mounted() {
		this.selectTabs();
	},
};

</script>



// WEBPACK FOOTER //
// _source/javascripts/modules/poll/polls.vue